/**
 * Created by andrey on 17.08.18.
 */

const Placements = function () { 
    this.data = Placements.ENTRIES;

    this.sortKeys();

    this.load();

    cleverapps.whenAllInitialized(() => {
        this.run(Placements.STARTUP);

        cleverapps.gameManager.on("resume", cleverapps.throttle(1000, () => {
            this.run(Placements.ONSHOW);
        }));

        const toRemove = Object.keys(this.lastStarts)
            .filter((code) => !this.data[code] || !this.data[code].interval);

        if (toRemove.length > 0) {
            for (const code of toRemove) {
                delete this.lastStarts[code];
            }
            this.save();
        }
    });
};

Placements.prototype.onFocusLostListenerPlacements = function () {
    if (cleverapps.environment.isMainScene() && cleverapps.meta.getSelectedLocation().locationConfig.isMain) {
        this.run(Placements.FREE_FOCUS_MAIN);
    } else if (cleverapps.environment.isGameScene()) {
        this.run(Placements.FREE_FOCUS_GAME);
    } else {
        this.run(Placements.FREE_FOCUS_OTHER);
    }
};

Placements.prototype.sortKeys = function () {
    this.sortedKeys = Object.keys(this.data);
    this.sortedKeys.sort((a, b) => {
        a = this.data[a];
        b = this.data[b];
        return (b.priority || 0) - (a.priority || 0);
    });

    this.keysByType = {};
};

Placements.prototype.listKeys = function (type) {
    if (this.keysByType[type]) {
        return this.keysByType[type];
    }

    const key = this.sortedKeys.filter(function (code) {
        const placement = this.data[code];
        return (placement.type & type) !== 0;
    }, this);
    this.keysByType[type] = key;
    return key;
};

Placements.prototype.resetAllPlacements = function () {
    this.lastStarts = {};
    this.onceStarts = {};
    this.resetThrottle();
    this.save();
};

Placements.prototype.getThrottleInterval = function () {
    return cleverapps.parseInterval(cleverapps.gameModes.fastPlacementsThrottle ? Placements.THROTTLE_INTERVAL_FAST : Placements.THROTTLE_INTERVAL);
};

Placements.prototype.resetThrottle = function () {
    this.throttledCount = 0;
    this.throttledTime = 0;
    this.heldPlacements = [];
};

Placements.prototype.isThrottleEnabled = function () {
    if (cleverapps.gameModes.noPlacementsThrottle) {
        return false;
    }

    return Boolean(cleverapps.config.debugMode) || Boolean(ABExperiments.Tests) && cleverapps.abExperiments.getGroup(ABExperiments.Tests.throttle) === "A";
};

Placements.prototype.refreshThrottle = function () {
    if (this.throttledTime + this.getThrottleInterval() <= Date.now()) {
        this.resetThrottle();
    }
};

Placements.prototype.addThrottledStart = function () {
    this.throttledCount++;
    this.throttledTime = Date.now();
};

// for the debug panel and the tool
Placements.prototype.getThrottleState = function () {
    this.refreshThrottle();

    return {
        count: this.throttledCount,
        leftTime: this.throttledTime ? Math.max(0, this.throttledTime + this.getThrottleInterval() - Date.now()) : 0,
        held: this.heldPlacements
    };
};

Placements.prototype.run = function (type, options) {
    if (!cleverapps.allInitialized) {
        return;
    }

    options = options || {};

    let changed = false;

    this.refreshThrottle();
    this.heldPlacements = [];

    const keys = this.listKeys(type);
    for (let i = 0; i < keys.length; i++) {
        const code = keys[i];
        const placement = this.data[code];

        if ((typeof placement.once === "function" ? placement.once() : placement.once) && this.onceStarts[code]) {
            continue;
        }

        if (placement.interval) {
            const placementInterval = typeof placement.interval === "function" ? placement.interval() : placement.interval;

            const interval = cleverapps.parseInterval(placementInterval);
            const lastStart = this.lastStarts[code] || 0;
            if (lastStart + interval > Date.now()) {
                continue;
            }
        }

        if (placement.delayFromStart && !options.skipDelayFromStart) {
            const delayFromStart = cleverapps.parseInterval(placement.delayFromStart);
            const start = cleverapps.timeStart;
            if (start + delayFromStart > Date.now()) {
                continue;
            }
        }

        if (placement.filter && !placement.filter() || cleverapps.config.demoMode) {
            continue;
        }

        const systemFault = (placement.type & Placements.SYSTEM_FAULT) !== 0;
        const willUseFocus = (placement.type & Placements.FREE_FOCUS) !== 0 && !systemFault;

        if (willUseFocus && cleverapps.focusManager.isFocused()) {
            continue;
        }

        if (placement.throttled && this.isThrottleEnabled() && this.throttledCount >= Placements.THROTTLE_LIMIT) {
            this.heldPlacements.push(code);
            continue;
        }

        placement.action();

        if (placement.interval) {
            this.lastStarts[code] = Date.now();
            changed = true;
        }

        if (typeof placement.once === "function" ? placement.once() : placement.once) {
            this.onceStarts[code] = true;
            changed = true;
        }

        if (willUseFocus && cleverapps.focusManager.isFocused()) {
            if (cleverapps.config.debugMode) {
                cleverapps.eventBus.trigger("runPlacement", code);
            }

            if (placement.throttled) {
                this.addThrottledStart();

                const focus = cleverapps.focusManager.getFocus();
                cleverapps.metrics.logEvent(cleverapps.EVENTS.PLACEMENTS.SHOWN, { itemId: focus });
                cleverapps.abExperiments.allLogEvent(cleverapps.EVENTS.PLACEMENTS.SHOWN, { itemId: focus });
            }

            break;
        }
    }

    if (changed) {
        this.save();
    }
};

Placements.prototype.load = function () {
    const info = cleverapps.dataLoader.load(DataLoader.TYPES.PLACEMENTS) || {};
    this.onceStarts = info.onceStarts || {};
    this.lastStarts = info.lastStarts || {};
    this.resetThrottle();
};

Placements.prototype.save = function () {
    cleverapps.dataLoader.save(DataLoader.TYPES.PLACEMENTS, this.getInfo());
};

Placements.prototype.getInfo = function () {
    return {
        lastStarts: this.lastStarts
    };
};

Placements.THROTTLE_LIMIT = 2;
Placements.THROTTLE_INTERVAL = "1 minute";
Placements.THROTTLE_INTERVAL_FAST = "5 seconds";

Placements.STARTUP = 1 << 0;
Placements.ONSHOW = 1 << 1;
Placements.INTERMEDIATE = 1 << 2;
Placements.AFTER_GAME_FINISH = 1 << 4;

Placements.FREE_FOCUS_MAIN = 1 << 5;
Placements.FREE_FOCUS_GAME = 1 << 6;
Placements.FREE_FOCUS_OTHER = 1 << 7;

Placements.SYSTEM_FAULT = 1 << 8;

Placements.ONSHOW_OR_STARTUP = Placements.ONSHOW | Placements.STARTUP;
Placements.INTERMEDIATE_OR_AFTER_FINISH = Placements.INTERMEDIATE | Placements.AFTER_GAME_FINISH;

Placements.FREE_FOCUS = Placements.FREE_FOCUS_MAIN | Placements.FREE_FOCUS_GAME | Placements.FREE_FOCUS_OTHER;
